import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import 'jquery';
import { TextInput } from '@bingads-webui-react/text-input';
import { HelpIcon } from './help-icon';

const DEFAULT_MAX_LENGTH = 90;
export class DefaultTextEditorView extends Component {
  static defaultProps = {
    maxLength: DEFAULT_MAX_LENGTH,
    enableCancel: true,
    defaultText: '',
  };

  constructor(props) {
    super(props);
    const { defaultText } = props;
    this.state = {
      data: defaultText,
      errorMessage: this.onValidate(defaultText),
      prevPropsDefaultText: defaultText,
      onValidate: this.onValidate.bind(this),
    };
  }

  // update state when props update
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.defaultText !== prevState.prevPropsDefaultText) {
      return {
        data: nextProps.defaultText,
        errorMessage: prevState.onValidate(nextProps.defaultText),
        prevPropsDefaultText: nextProps.defaultText,
      };
    }
    return null;
  }

  onSaveOrOnCancel = (isCancel, event) => {
    this.props.onSaveOrOnCancel(isCancel ? '' : this.state.data, event);
  };

  onCancelClicked = (event) => {
    this.onSaveOrOnCancel(true, event);
  };

  onSaveClicked = (event) => {
    this.onSaveOrOnCancel(false, event);
  };

  onValidate = (model) => {
    const { maxLength, i18n, enableCancel } = this.props;
    // max length check
    if (model && maxLength && maxLength > 0 && model.length > maxLength) {
      return i18n.getString('DefaultText_Max_length_validation', { count: maxLength });
    }

    // min length check for disable cancel
    if (!enableCancel && ((!model) || model.length === 0)) {
      return i18n.getString('DefaultText_Required_validation');
    }
    return null;
  };

  onChange = (e) => {
    const data = e.target.value;
    const model = data.trim();
    const errorMessage = this.onValidate(model);

    this.setState({ data, errorMessage });
  };

  getErrorMessage = () => (this.state.errorMessage ? (
    <div role="alert" className="error edit-error-messages">
      {this.state.errorMessage}
    </div>
  ) : null);

  render() {
    const { i18n, enableCancel } = this.props;
    const inputId = 'default_text_input';

    /*  eslint-disable jsx-a11y/label-has-for */
    return (
      <div className="default-value-input">
        <div className="display-inline-block u-full-width">
          <div className="col-sm-4">
            <label className="control-label" htmlFor={inputId}>
              {i18n.getString('DefaultText_Label')}
            </label>
            <HelpIcon topic="pop_BA_NewAdCreate_AdCustomizer_DefaultText" />
          </div>
          <div className="col-sm-8">
            <TextInput
              onChange={this.onChange}
              value={this.state.data}
              id={inputId}
              className={classnames('form-control', 'display-inline-block')}
            />
          </div>
          {this.getErrorMessage()}
        </div>
        <div className="display-inline-block u-full-width">
          <input
            className="btn btn-primary"
            type="button"
            disabled={this.state.errorMessage}
            onClick={this.onSaveClicked}
            value={i18n.getString('Save')}
          />
          {enableCancel ? <input
            className="btn btn-default"
            type="button"
            onClick={this.onCancelClicked}
            value={i18n.getString('Cancel')}
          /> : null}
        </div>
      </div>
    );
  }
}

DefaultTextEditorView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  defaultText: PropTypes.string,
  maxLength: PropTypes.number,
  onSaveOrOnCancel: PropTypes.func.isRequired,
  enableCancel: PropTypes.bool,
};
